import { useParams } from "react-router";
import { QueryState } from "@/components/query-state";
import { DesignerPage } from "@/features/cms/designer/DesignerPage";
import { PageEditor } from "@/features/cms/editor/page-editor";
import { PagesTable } from "@/features/cms/pages-table";
import { useCmsPage } from "@/features/cms/queries";

export function CmsPagesPage() {
  return (
    <PagesTable
      title="Pages"
      description="Landing-site pages built from blocks. Drafts are private until published."
      kinds={["page", "product", "legal"]}
      editBase="/cms/pages"
    />
  );
}

export function CmsPostsPage() {
  return (
    <PagesTable
      title="Posts"
      description="Blog posts and changelog entries; same block editor, listed by kind."
      kinds={["post", "changelog"]}
      editBase="/cms/pages"
    />
  );
}

export function CmsPageEditPage() {
  const { id = "" } = useParams();
  const page = useCmsPage(id);
  return (
    <QueryState query={page} rows={8}>
      {(p) => (
        <PageEditor
          key={p.id}
          page={p}
          backTo={p.kind === "post" || p.kind === "changelog" ? "/cms/posts" : "/cms/pages"}
        />
      )}
    </QueryState>
  );
}

/** `/cms/pages/:id/design` — the full-screen visual designer (outside the Shell layout). */
export function CmsPageDesignPage() {
  return <DesignerPage />;
}
